module.exports = __webpack_public_path__ + "img/id_card_country.acbd2a72.png";